<template>
  <section id="default-page-template">
    <div class="coverPhoto" style="background-image: url(img/agent-cover-export.jpg)">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-8">
            <div class="header-title">
              <h2>
                Plotesoni formen per t'u bere
                <span>partner</span>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row align-items-center">
        <div class="col-12">
          <div class="white-content">
            <!-- start radio buttons -->
            <div class="col-lg-12">
              <div class="form-group">
                <div class="styled-input-single">
                  <input
                      type="radio"
                      name="fieldset-3"
                      id="radio-example-five"
                      @click="getSubscriberType('individual')"
                      checked
                  >
                  <label for="radio-example-five">Person Individual</label>
                </div>
                <div class="styled-input-single">
                  <input
                      type="radio"
                      name="fieldset-3"
                      id="radio-example-six"
                      @click="getSubscriberType('company')"
                  >
                  <label for="radio-example-six">Biznes/Institucion</label>
                </div>
              </div>
              <div class="col-12">
                <hr>
              </div>
              <div v-if="partnerType === 'individual'">
                <PartnerFormIndividual/>
              </div>
              <div v-if="partnerType === 'company'">
                <PartnerFormBusiness/>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import PartnerFormIndividual from "@/components/PartnerFormIndividual.vue";
import PartnerFormBusiness from "@/components/PartnerFormBusiness.vue";

export default {
  name: "PartnerForm",
  data() {
    return {
        partnerType: 'individual'
    }
  },
  components: {
    PartnerFormIndividual,
    PartnerFormBusiness,
  },
  methods: {
    getSubscriberType(value) {
      this.$store.dispatch('partnersForm/getVehicles', [
        {
          vehicle_registration: "",
          vehicle_model: "",
          vehicle_year: "",
          vehicle_photos: {},
        }
      ]);
      this.partnerType = value;
    },
  },
}
</script>

<style scoped>

</style>